import React from 'react';
import { Navigate } from 'react-router-dom';

import { IUserInfo } from '@/types/auth';
import { ConstantUtil } from '@/utils/ConstantUtil';

interface PermissionGuardProps {
  children: React.ReactNode;
  requiredPermission?: string;
  fallbackPath?: string;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({ 
  children, 
  requiredPermission,
  fallbackPath = '/dashboard'
}) => {
  // 獲取用戶資訊
  const getUserInfo = (): IUserInfo | null => {
    try {
      const userInfoStr = localStorage.getItem(ConstantUtil.STORAGE_USER_INFO);
      if (userInfoStr) {
        return JSON.parse(userInfoStr) as IUserInfo;
      }
    } catch (error) {
      console.error('獲取用戶資訊失敗:', error);
    }
    return null;
  };

  // 獲取用戶權限
  const getUserPermissions = (): string[] => {
    const userInfo = getUserInfo();
    if (userInfo) {
      // 如果是 admin 用戶，自動賦予所有權限（包括新添加的權限）
      if (userInfo.email === 'admin@uuspa.com') {
        return Object.values(ConstantUtil.PERMISSIONS);
      }
      return userInfo.permissions || [];
    }
    return [];
  };

  // 檢查權限
  const hasPermission = (permission?: string): boolean => {
    if (!permission) return true; // 沒有權限要求則允許訪問
    const userPermissions = getUserPermissions();
    return userPermissions.includes(permission);
  };

  // 如果沒有權限，重定向到指定頁面
  if (!hasPermission(requiredPermission)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default PermissionGuard;
